/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconDeviceIpadCode = createReactComponent("outline", "device-ipad-code", "IconDeviceIpadCode", [["path", { "d": "M11.5 21h-5.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8", "key": "svg-0" }], ["path", { "d": "M9 18h2", "key": "svg-1" }], ["path", { "d": "M20 21l2 -2l-2 -2", "key": "svg-2" }], ["path", { "d": "M17 17l-2 2l2 2", "key": "svg-3" }]]);

export { IconDeviceIpadCode as default };
//# sourceMappingURL=IconDeviceIpadCode.mjs.map
